import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { clientStore } from 'apps/client/app';
import { isMobile } from 'styles/utils';

import { throttle } from 'throttle-debounce';

@observer
export class ClientContext extends React.Component {
  handleScroll = throttle(500, () => {
    // throttle eventListener via requestAnimationFrame and 'checking' state
    if (!clientStore.checkingScroll) {
      clientStore.setCheckingScroll(true);
      window.requestAnimationFrame(() => {
        clientStore.setScrollTop(window.scrollY);
        clientStore.setCheckingScroll(false);
      });
    }
  });

  handleResize = () => {
    clientStore.setWindowSize(window.innerWidth, window.innerHeight);
    clientStore.SetIsMobile(isMobile());
    // On mobile when the hamburger menu panel or the notification panel are open the main scroll is disabled to avoid 2 scrolls at the same time.
    // The next code active the main scroll when the user is not on mobile any more. It runs when the viewport is greater than the 'large' theme breakpoint.
    if (!isMobile('large')) {
      document.querySelector('html').style.overflowY = 'initial';
      document.body.style.overflowY = 'initial';
    }
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }

  render() {
    return this.props.children;
  }
}

ClientContext.propTypes = {
  children: PropTypes.node,
};
